import { useEffect } from 'react';

export function ConditionalAdSense() {
  useEffect(() => {
    // Skip in development mode
    if (process.env.NODE_ENV === 'development') {
      return;
    }

    // Check if script already exists
    const existingScript = document.querySelector('script[src*="adsbygoogle"]');
    if (existingScript) {
      return;
    }

    // Create and inject AdSense script
    const script = document.createElement('script');
    script.src = 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-2729367668902676';
    script.async = true;
    script.crossOrigin = 'anonymous';
    
    script.onerror = () => {
      console.warn('Failed to load AdSense script');
    };

    document.head.appendChild(script);

    // Cleanup function
    return () => {
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, []);

  return null;
}
